import React, { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
const Cookies = require("js-cookie");

const UserContext = createContext();

export const useUserContext = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [resolvePromise, setResolvePromise] = useState(null);

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    }
  }, [user]);

  const login = (userData) => setUser(userData);

  const logout = () => {
    setUser(null);
    Cookies.remove("token");
    localStorage.clear();
  };

  const userRole = () => {
    const token = getToken();
    if (token) {
      const decodedToken = jwtDecode(token);
      return decodedToken?.role || null;
    } else {
      logout();
    }
    return null;
  };

  const requestConfirmation = (msg) => {
    return new Promise((resolve) => {
      setConfirmationMessage(msg);
      setResolvePromise(() => resolve); // Save the resolve function to call later
      setShowConfirmationPopup(true); // Show the modal
    });
  };

  const handleConfirm = (result) => {
    // setIsConfirmed(result);
    setShowConfirmationPopup(false);
    if (resolvePromise) {
      resolvePromise(result); // Resolve the promise with the user's choice (true/false)
    }
  };

  const handleCancel = () => {
    // setIsConfirmed(false);
    setShowConfirmationPopup(false);
    if (resolvePromise) {
      resolvePromise(false); // Resolve the promise with false if user cancels
    }
  };

  const getToken = () => {
    const token = Cookies.get("token");
    if (!token) {
      return "";
    }
    // const parts = token.split(".");
    // if (parts.length !== 3) {
    //   return "";
    // }
    // const decodedToken = jwtDecode(token);
    // const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    // // if (decodedToken.exp < currentTimeInSeconds) {
    // //   return "";
    // // }
    return token;
  };

  return (
    <UserContext.Provider
      value={{
        user,
        login,
        logout,
        userRole,
        showConfirmationPopup,
        setShowConfirmationPopup,
        confirmationMessage,
        Cookies,
        getToken,

        requestConfirmation,
        handleConfirm,
        handleCancel,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
